import { doc } from "firebase/firestore";
import { createContext, useEffect, useState } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { auth, db } from "../firebase";
import initialUser from "./InitialUserContext";
import { getPhonicResults } from "../utils/gameUtils";

const UserContext = new createContext({ user: null });

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(initialUser);

  const [data] = useDocument(doc(db, "users", auth.currentUser?.uid ?? "-1"), {
    snapshotListenOptions: { includeMetadataChanges: true },
  });

  const getUserPhonicResults = () => {
    return getPhonicResults(user?.roundsPlayed);
  };

  useEffect(() => {
    if (data?.exists()) setUser(data?.data());
  }, [data]);

  const getRounds = (gameName, areCorrect = true, alternativeUserData) => {
    const selectedUser = alternativeUserData ?? user;
    return selectedUser.roundsPlayed?.filter(
      ({ gameId, correct }) => gameId === gameName && correct === areCorrect
    );
  };

  return (
    <UserContext.Provider
      value={{ user, setUser, getRounds, getUserPhonicResults }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
